// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"287":"de4dfed0","498":"6810c7e0","703":"9cc76faf","787":"63b307b6"}[chunkId] + ".chunk.js";
};